import {
  Tooltip as ChakraTooltip,
  TooltipProps as ChakraTooltipProps,
} from "@chakra-ui/react"
import { tokens } from "DesignSystem/tokens"
import React, { PropsWithChildren } from "react"

type WhitelistedChakraTooltipProps = Pick<
  ChakraTooltipProps,
  | "placement"
  | "label"
  | "isOpen"
  | "closeOnScroll"
  | "openDelay"
  | "shouldWrapChildren"
  | "isDisabled"
>

/**
 * ### Tooltip
 *
 * A tooltip is a brief, informative message that appears when a user interacts with an element.
 *
 * ### Example
 * ```
 * <Tooltip label="This is the tooltip" placement="bottom">
 *   <Button>Hover me</Button>
 * </Tooltip>
 * ```
 **/
export const Tooltip: React.FC<
  PropsWithChildren<WhitelistedChakraTooltipProps>
> = ({ children, ...props }) => {
  return (
    <ChakraTooltip
      px={3}
      py={1.5}
      maxW="300px"
      color="ds.text.inverse"
      bg="ds.background.neutral.bolder.resting"
      boxShadow="ds.overlay"
      borderRadius="8px"
      sx={{ ...tokens.textStyles.ds.paragraph.primary }}
      {...props}
    >
      {children}
    </ChakraTooltip>
  )
}
